/**
 * Ranges of dates.
 */

const dateRangesNew = [
    { id: "yesterday", label: "T-7", max: -7},
    { id: "one-day", label: "Today", max: 0 },
    { id: "two-day", label: "T+1", max: 1 },
    { id: "three-day", label: "T+2", max: 2 },
    { id: "four-day", label: "T+3", max: 3 },
  ]
  
  export const getDateRangeById1 = id =>
    dateRangesNew.find(range => range.id === id)
  
  export default dateRangesNew
